import { render, staticRenderFns } from "./DescriptionRecordsForm.vue?vue&type=template&id=5184d6fb&"
import script from "./DescriptionRecordsForm.vue?vue&type=script&lang=js&"
export * from "./DescriptionRecordsForm.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionRecordsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VTextarea,
})
